import { UIHeading5 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './HintQuestion.css';

interface IHintQuestionProps {
  text: string;
  onClick(text: string): void;
  isRedesignedBlock?: boolean;
}

export const HintQuestion: React.FC<IHintQuestionProps> = ({ text, onClick, isRedesignedBlock }) => {
  return (
    <span
      className={cx(styles['container'], isRedesignedBlock && styles['container-redesigned'])}
      onClick={() => onClick(text)}
    >
      <UIHeading5 color="text-main-default" whiteSpace="nowrap">
        {text}
      </UIHeading5>
    </span>
  );
};
